// 菜单 侧边栏
export default [
  { title: '产品管理',
    icon: 'home',
    children: [
      { path: '/guestbook', title: '留言板管理' }
    ]
  }
]
